import React, { forwardRef } from 'react'
import Lottie, { LottieProps } from 'react-lottie'

const LottieAnimation = forwardRef<Lottie, LottieProps>((props, ref) => {
  return <Lottie ref={ref} {...props} />
})

export default LottieAnimation
